import App from "./components/App.jsx";
import {initializeDialogueTheme} from "../../../../../shared/js";
import {QUESTION_STYLE_MSG_KEYS} from "../../../../../shared/js/i18n/custom/question-styles/index.mjs";

// noinspection JSIgnoredPromiseFromCall
initializeDialogueTheme({
    ThemeComponent: App,
    questionStylesKey: QUESTION_STYLE_MSG_KEYS.bubble,
    webFont: {
        typekit: {
            id: 'rpz7kbg'
        }
    }
});
